import noUiSlider from 'nouislider';
import jQueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';
import accounting from 'accounting';

export default {
  init() {
    jQueryBridget( 'isotope', Isotope, $ );

    var prices = [];

    $('.home-card').each(function() {
      prices.push( parseInt($(this).data('price'), 10) );
    })

    prices.sort(function(a, b) {
      return a - b;
    });

    var minPrice = prices[0];
    var maxPrice = prices[prices.length - 1];
    var minPriceFormatted = accounting.formatMoney(minPrice, { precision: 0 });
    var maxPriceFormatted = accounting.formatMoney(maxPrice, { precision: 0 });

    $('#sliderValueMin').text(minPriceFormatted);
    $('#sliderValueMax').text(maxPriceFormatted);

    function filterPrices() {
      var values = priceSlider.get();
      var min = values[0];
      var max = values[1];

      $grid.isotope({
        filter: function() {
          var homePrice = parseInt($(this).find('.home-card').data('price'), 10);
          return ( (homePrice >= min) && (homePrice <= max) );
        },
      });
    }

    var priceSlider = noUiSlider.create($('#slider')[0] , {
      start: [minPrice, maxPrice],
      connect: true,
      range: {
        'min': minPrice,
        'max': maxPrice,
      },
      format: {
        to: Math.round,
        from: Number,
      },
    });

    priceSlider.on('change', function() {
      filterPrices();
    });

    priceSlider.on('update', function(values, handle) {
      var value = values[handle];
      var price = accounting.formatMoney(value, { precision: 0 });
      var $priceLabel;

      if (handle === 0) {
        $priceLabel = $('#sliderValueMin');
      } else {
        $priceLabel = $('#sliderValueMax');
      }

      $priceLabel.text(price);
    });

    var $grid = $('.grid').isotope({
      itemSelector: '.grid-item',
      layoutMode: 'fitRows',
    });

    $('#filterType').on('change', function() {
      // Hide all filters
      $('[data-filter-name]').hide();

      if (this.value === '*') {
        $grid.isotope({ filter: '*' });
      } else {
        var thisFilter = $('[data-filter-name="' + this.value + '"]');

        // Trigger change event so isotope gets filtered
        if ( thisFilter.hasClass('archive-filters__select') ) {
          thisFilter.trigger('change');
        } else if(thisFilter.find('#slider').length) {
          filterPrices();
        }

        // Show just the one filter selected
        thisFilter.show();
      }
    });

    // Simple filter for select options
    $('.archive-filters__select[data-filter-name]').on('change', function() {
      $grid.isotope({
        filter: this.value,
      });
    });
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-home-archive.js